<div class="genericPage">
  <br />
  <br />
  <div class="ui-g-12 ui-lg-8 ui-g-nopad">
    <h1 class="step-title">{{labels.title}}</h1>
  </div>
  <div class="ui-g-12 ui-lg-4 text-right">
    <button
    pButton
    type="button"
    class="k-generic-btn"
    icon="fa fa-angle-left"
    iconPos="left"
    label="{{ 'common.back' | translate }}"
    (click)="onClickBack()"></button>    
  </div>

  <p-tabView (onChange)="onChangeTab($event)" [styleClass]="'kTabView'" *ngIf="show.tabView">
    <p-tabPanel header="{{'voucherCouponsMg.tabWebLog' | translate}}"  [headerStyle]="{'width': (100/shownTabs.total) + '%'}" [headerStyleClass]="'kTabHead'">
      <app-web-log [couponVoucherId]="couponVoucherId" *ngIf="show.weblog"></app-web-log>
    </p-tabPanel>
    <p-tabPanel header="{{'voucherCouponsMg.tabEmission' | translate}}" [headerStyle]="{'width': (100/shownTabs.total) + '%'}" [headerStyleClass]="'kTabHead'">
      <app-emission [couponVoucherId]="couponVoucherId" *ngIf="show.emission"></app-emission>      
    </p-tabPanel>
    <p-tabPanel header="{{'voucherCouponsMg.title_Use' | translate}}" [headerStyle]="{'width': (100/shownTabs.total) + '%'}" [headerStyleClass]="'kTabHead'">
      <app-use [couponVoucherId]="couponVoucherId" *ngIf="show.use"></app-use>
    </p-tabPanel>
  </p-tabView>
</div>


// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/voucher-coupon-mg-detail.component.html